/*
  Bambusa — allègement des images (2026-08-18)
  ------------------------------------------------------------------
  Deux fuites mesurées en production le 18/08/2026 :

  1) Section « Récemment consultés »
     theme.Images.buildImagePath(url) appelé SANS liste de largeurs renvoie
     l'URL ORIGINALE. setupOutput() la pose en .src AVANT .srcset et .sizes :
     Chrome lance le téléchargement sur le src et ignore le srcset arrivé
     trop tard. Mesuré sur /products/phyllostachys-nigra : 1 209 + 1 015 +
     855 + 723 Ko téléchargés pour des vignettes de 266 px.
     -> on redéfinit buildImagePath pour qu'il renvoie toujours une URL
        dimensionnée, et qu'il construise des candidats srcset propres
        (le code d'origine concatène « ?width= » à la main, ce qui casse
        les URL qui portent déjà « ?v= »).

  2) Image de survol des grilles produit (.grid-product__secondary-image)
     Elle est en loading="lazy" mais elle occupe la même case que l'image
     principale : dès que la carte entre dans le viewport, elle se télécharge,
     survol ou pas. Mesuré sur /collections/erables-japonais : 39 images =
     4 499 Ko, soit 47 % du poids de la page.
     -> on retire src/srcset au chargement et on les rétablit au premier
        survol de la carte. Sur écran tactile (aucun survol possible) on ne
        fait rien : la classe small--hide masque déjà le bloc.

  Aucun fichier de rendu n'est modifié : tout se fait à l'exécution, donc
  le correctif se retire en supprimant la balise <script> de
  snippets/social-meta-tags.liquid.
*/
(function () {
  'use strict';

  var PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var DEFAULT_WIDTH = 540;

  function sizedUrl(url, width) {
    try {
      var u = new URL(url, window.location.href);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  /* ------------------------------------------------------------------
     1. Récemment consultés
     ------------------------------------------------------------------ */
  function patchBuildImagePath() {
    if (!window.theme || !window.theme.Images) return false;
    if (window.theme.Images.__bambusaSized) return true;

    window.theme.Images.buildImagePath = function (string, widths) {
      if (string === null || string === undefined || string === '') return [];
      if (!widths || !widths.length) return [sizedUrl(string, DEFAULT_WIDTH)];
      return widths.map(function (w) {
        return sizedUrl(string, w) + ' ' + w + 'w';
      });
    };
    window.theme.Images.__bambusaSized = true;
    return true;
  }

  /* Les gabarits <template> clonés pour construire les vignettes :
     on y pose loading="lazy" une fois pour toutes. */
  function lazyTemplates() {
    ['naturalImageMarkup', 'fixedRatioImageMarkup'].forEach(function (id) {
      var tpl = document.getElementById(id);
      if (!tpl || !tpl.content) return;
      var img = tpl.content.querySelector('img');
      if (img && !img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
    });
  }

  /* ------------------------------------------------------------------
     2. Image de survol
     ------------------------------------------------------------------ */
  function hold(img) {
    if (!img || img.hasAttribute('data-bmb-hold')) return;
    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');
    if (!src && !srcset) return;
    if (src && src.indexOf('data:') !== 0) img.setAttribute('data-bmb-src', src);
    if (srcset) img.setAttribute('data-bmb-srcset', srcset);
    img.setAttribute('data-bmb-hold', '1');
    img.removeAttribute('srcset');
    img.setAttribute('src', PLACEHOLDER);
  }

  function release(scope) {
    var imgs = scope.querySelectorAll('img[data-bmb-hold]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var ss = img.getAttribute('data-bmb-srcset');
      var s = img.getAttribute('data-bmb-src');
      if (ss) img.setAttribute('srcset', ss);
      if (s) img.setAttribute('src', s);
      img.removeAttribute('data-bmb-hold');
      img.removeAttribute('data-bmb-src');
      img.removeAttribute('data-bmb-srcset');
    }
  }

  function holdAll() {
    var wraps = document.querySelectorAll('.grid-product__secondary-image');
    for (var i = 0; i < wraps.length; i++) {
      var imgs = wraps[i].getElementsByTagName('img');
      for (var j = 0; j < imgs.length; j++) hold(imgs[j]);
    }
  }

  function onPointer(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.grid-product, .grid__item');
    if (!card) return;
    if (card.querySelector('img[data-bmb-hold]')) release(card);
  }

  function boot() {
    patchBuildImagePath();
    lazyTemplates();

    /* Écran sans survol (mobile, tablette) : le bloc est déjà masqué par
       small--hide, on ne touche à rien. */
    if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

    holdAll();
    document.addEventListener('mouseover', onPointer, { passive: true });
    document.addEventListener('focusin', onPointer, { passive: true });

    /* Les filtres de collection et le défilement infini réinjectent la grille. */
    if (window.MutationObserver && document.body) {
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(holdAll, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  patchBuildImagePath();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', patchBuildImagePath);
})();
